import Vue from "vue";
import VueRouter from "vue-router";
import VueMeta from "vue-meta";
import axios from "axios";
import { posthog } from "@/main";

Vue.use(VueRouter);
Vue.use(VueMeta);

// vue-router 3.1+ rejects redundant navigation (e.g. auth guards pushing to
// the current route), surfacing as unhandled "Error: t" rejections in prod.
// Swallow only that case; real navigation failures still propagate.
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) {
        return originalPush.call(this, location, onResolve, onReject);
    }
    return originalPush.call(this, location).catch((err) => {
        if (err && (err.name === "NavigationDuplicated" ||
            /Navigating to current location/.test(err.message || ""))) {
            return err;
        }
        throw err;
    });
};
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
    if (onResolve || onReject) {
        return originalReplace.call(this, location, onResolve, onReject);
    }
    return originalReplace.call(this, location).catch((err) => {
        if (err && (err.name === "NavigationDuplicated" ||
            /Navigating to current location/.test(err.message || ""))) {
            return err;
        }
        throw err;
    });
};

// router setup
import routes from "./routes";

// configure router
const router = new VueRouter({
    mode: "history",
    routes, // short for routes: routes
    scrollBehavior: (to) => {
        if (to.hash) {
            return { selector: to.hash };
        } else {
            return { x: 0, y: 0 };
        }
    },
    linkExactActiveClass: "nav-item active",
});

// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
    const subsequentMiddleware = middleware[index];
    // If no subsequent Middleware exists,
    // the default `next()` callback is returned.
    if (!subsequentMiddleware) return context.next;

    return (...parameters) => {
        // Run the default Vue Router `next()` callback first.
        context.next(...parameters);
        // Then run the subsequent Middleware with a new
        // `nextMiddleware()` callback.
        const nextMiddleware = nextFactory(context, middleware, index + 1);
        subsequentMiddleware({ ...context, next: nextMiddleware });
    };
}

router.beforeEach((to, from, next) => {
    // NProgress.start()
    // NProgress.set(0.1)
    if (to.meta.middleware) {
        const middleware = Array.isArray(to.meta.middleware) ?
            to.meta.middleware : [to.meta.middleware];
        const context = { from, next, to, router };
        const nextMiddleware = nextFactory(context, middleware, 1);

        return middleware[0]({ ...context, next: nextMiddleware });
    }
    return next();
});

router.afterEach(async (to, from) => {
    posthog.capture('$pageview', { $current_url: window.location.href });
    await router.app.$store.dispatch('authenticateUser', { reload: true });
    router.app.$store.dispatch("getNotificationList", { user_id: router.app.$store.getters["user/user_id"] });

    const options = {
        headers: {
            Accept: "application/vnd.api+json",

            "Content-Type": "application/vnd.api+json",
        },
    };
    let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
    );
    if (!currentSession) {
        var result = "";
        var randomChars =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < 20; i++) {
            result += randomChars.charAt(
                Math.floor(Math.random() * randomChars.length)
            );
        }
        currentSession = result;
    }

    axios.post(
        process.env.VUE_APP_API_BASE_URL + "/session/activity_track", {}, {
        params: {
            session_id: currentSession,
            ip: localStorage.getItem('userIP'),
            url: to.path,
        },
    },
        options
    );
});

export default router;